var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.attribute)?[_c('p',{style:({'margin-left': _vm.margin})},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.attribute.name)+":")]),_vm._v(" "),(_vm.codeData)?_c('span',[_vm._v(_vm._s(_vm.codeData.name))]):_vm._e()])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-626d6fe8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/OrderCodes.vue
// module id = null
// module chunks = 